<div class="w-40 h-40 p-4 mt-5 bg-white rounded-xl shadow relative flex flex-col items-center justify-center space-y-2">

    <!-- 🔰 Ribbon at top-left -->
    <div *ngIf="cardName != 'Autres justificatifs (CDC, Etude de dimensionnement, etc.)'" class="absolute top-0 left-0">
        <div class="bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-br-md">
            {{fileType ? fileType : cardName}}
        </div>
    </div>

    <div class="relative">
        <!-- File Icon -->
        <div class="relative w-9 h-14 bg-gray-200 rounded-md flex items-center justify-center shadow-md">
            <!-- The "file corner fold" -->
            <div class="absolute top-0 right-0 w-4 h-4 bg-white rounded-bl-md shadow-sm"></div>

            <!-- Extension label -->
            <span class="absolute bottom-1 left-1 text-xs font-bold text-white px-1 rounded" [ngClass]="extensionColor">
                {{ extensionLabel }}
            </span>
        </div>
    </div>

    <!-- File name, line break with ellipsis -->
    <div class="text-xs text-center break-all line-clamp-3">
        {{ fileName }}
    </div>

    <!-- 3-dot menu -->
    <div class="absolute top-4 right-2 cursor-pointer">
        <div class="relative" (click)="toggleMenu()">
            <button class="text-gray-400 hover:text-gray-600 focus:outline-none text-lg">⋮</button>

            <!-- Dropdown menu -->
            <div *ngIf="menuOpen"
                class="absolute right-0 mt-1 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                <button class="w-full px-4 py-2 flex items-center gap-2 hover:bg-gray-100"
                    (click)="downloadFile()">
                    <mat-icon svgIcon="heroicons_outline:download" class="h-4 w-4"></mat-icon>
                    Télécharger
                </button>

                <button class="w-full px-4 py-2 flex items-center gap-2 hover:bg-gray-100"
                    (click)="deleteFile()">
                    <mat-icon svgIcon="heroicons_outline:trash" class="h-4 w-4"></mat-icon>
                    Supprimer
                </button>

            </div>
        </div>
    </div>
</div>